import type { CartPreview } from '../../bot-core/types/chat.types';
import type { CheckoutPayload } from '../types/bot.types';

/** Map live checkout payload → cart preview card shape (chat footer). */
export function checkoutPayloadToCartPreview(payload: CheckoutPayload): CartPreview {
  return {
    items: payload.itinerary_display.map((item) => ({
      cart_item_id: item.cart_item_id,
      product_type: item.product_type,
      display_name: item.display_name,
      display_summary: item.display_summary,
      price: item.price,
      currency: item.currency,
    })),
    total_estimated_price: payload.total_estimated_price,
    currency: payload.currency,
    travellers: payload.travellers,
  };
}
